import promotionApi from '@/api/promotion';
import { RootState } from '@/store';
import { ActionContext, GetterTree, MutationTree } from 'vuex';
import {Promotion} from '@/consts/loyaltySystem/createPromotionPopup';
import BuyXGetY from '@/models/buyXGetY';
import {BuyXGetYProps} from '@/interfaces/models/buyXGetY';

interface PromotionsState {
  promotions: {
    buyXGetY: BuyXGetY[]
  },
  isFetchingPromotions: boolean,
  isPromotionsWasFetch: boolean,
}

const namespaced: boolean = true;

const getDefaultState = () => ({
  promotions: {
    buyXGetY: [],
  },
  isFetchingPromotions: false,
  isPromotionsWasFetch: false,
});

const state: PromotionsState = getDefaultState();

const getters: GetterTree<PromotionsState, RootState> = {};

const actions = {
  async fetchPromotions({ commit }: ActionContext<PromotionsState, RootState>) {
    if (!state.isPromotionsWasFetch && !state.isFetchingPromotions) {
      commit('setIsFetchingPromotions', true);

      const promotions = await promotionApi.fetchPromotions();

      commit('setPromotions', promotions);
      commit('setIsFetchingPromotions', false);
      commit('setIsPromotionsWasFetch', true);
    }
  },
  async createBuyXGetY({ dispatch }: ActionContext<PromotionsState, RootState>, promotion: Promotion) {
    promotionApi.createBuyXGetY(promotion);

    return dispatch(
      'socketCreateBuyXGetY',
      promotion,
      { root: true }
    );
  },
  async removeBuyXGetY({ dispatch }: ActionContext<PromotionsState, RootState>, id: string) {
    promotionApi.removeBuyXGetY(id);

    return dispatch(
      'socketRemoveBuyXGetY',
      { id },
      { root: true }
    );
  },
};

const mutations: MutationTree<PromotionsState> = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setPromotions(state, promotions: BuyXGetY[]) {
    state.promotions.buyXGetY = promotions;
  },
  createBuyXGetY(state, buyXGetYProps: BuyXGetYProps) {
    const buyXGetY = BuyXGetY.createFromRequest(buyXGetYProps);

    state.promotions.buyXGetY.push(buyXGetY);
  },
  removeBuyXGetY(state, removePromotionId: string) {
    const promotionIndex = state.promotions.buyXGetY.findIndex(({ id }: BuyXGetY): boolean => id === removePromotionId);

    if (-1 !== promotionIndex) {
      state.promotions.buyXGetY.splice(promotionIndex, 1);
    }
  },
  setIsFetchingPromotions(state, isFetchingPromotions: boolean) {
    state.isFetchingPromotions = isFetchingPromotions;
  },
  setIsPromotionsWasFetch(state, isPromotionsWasFetch: boolean) {
    state.isPromotionsWasFetch = isPromotionsWasFetch;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
